import React from 'react';
import styles from './index.module.scss';
import buildIcon from '../../public/static/images/build-icon.png';
import competeIcon from '../../public/static/images/compete-icon.png';
import dreamIcon from '../../public/static/images/dream-icon.png';

const exploreItems = [
  {
    title: 'Filters that are delightfully chaotic',
    description: 'Transform yourself and your friends within seconds',
    icon: dreamIcon,
  },
  {
    title: 'Making inside jokes instantly sharable',
    description:
      'Craft generators that your friends can riff on, remix, and escalate into full-blown bits',
    icon: buildIcon,
  },
  {
    title: 'More coming soon',
    description:
      'We’re still cooking up weird, wonderful tools to make you the captain of your group chat and we can’t wait for you to try them',
    icon: competeIcon,
  },
];

const Explore = ({ detailsRef }) => {
  return (
    <div
      id="learn-more-details"
      ref={detailsRef}
      className={styles.learnMoreDetails}
      role="region"
      aria-live="polite"
    >
      <div className={styles.learnMoreTextBlock}>
        <span>
          Get ready to explore a whole new world of joyful creative chaos.{' '}
        </span>
        <span>On BF Island, you’ll be able to:</span>
      </div>

      <div className={styles.itemsContainer}>
        <div className={styles.itemRow}>
          {exploreItems.slice(0, 3).map((item, index) => (
            <div key={index} className={styles.item}>
              <div className={styles.titleWrapper}>
                <img src={item.icon} alt="" aria-hidden="true" />
                <h3 className={styles.title}>{item.title}</h3>
              </div>
              <p className={styles.description}>{item.description}</p>
            </div>
          ))}
        </div>

        <div className={styles.itemRow}>
          {exploreItems.slice(3, 5).map((item, index) => (
            <div key={index} className={styles.item}>
              <div className={styles.titleWrapper}>
                <img src={item.icon} alt="" aria-hidden="true" />
                <h3 className={styles.title}>{item.title}</h3>
              </div>

              <p className={styles.description}>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Explore;
